import { buildApiQueryHook } from '../../utils/api'
import { BrandModelParams, BrandModelResultDto } from './BrandModel.dto'
import axios from 'axios'
import { SEARCH_BRAND_MODELS } from '../endpoints'

export const useBrandModels = buildApiQueryHook<BrandModelParams, BrandModelResultDto>(
  'brand-models',
  (params) => axios.get(SEARCH_BRAND_MODELS, { params: params }),
)
